import React from 'react';

const AcaTableCell = (props) => {
    const { 
        head = false,
        size = 'regular',
        field = false,
        children = null,
        center = false,
        grey = false,
        border = false,
        highlight = false,
        extraClasses = '',
        ...restProps 
    } = props;

    let allClasses = "acaTable__cell";
    switch (size) {
        case 'small':
            allClasses += ' acaTable__cell--small';
            break;
    }
    if ( center ) allClasses += ' acaTable__cell--center';
    if ( border ) allClasses += ' acaTable__cell--borderLeft';
    if ( grey ) allClasses += ' acaTable__cell--grey';
    if ( highlight ) allClasses += ' acaTable__cell--highlight';
    if ( extraClasses ) allClasses += ' ' + extraClasses;

    return (
        <>
        { head ? (
            <th className={allClasses} data-field={field}>
                {children}
            </th>
        ) : (
            <td className={allClasses} data-field={field}>
                {children}
            </td>
        ) }
        </>
    );
}

const AcaTableHeader = (props) => {
    const { 
        children = null,
        ...restProps 
    } = props;

    return (
        <thead className="acaTable__header">
            <tr>
                {children}
            </tr>
        </thead>
    );

}

const AcaTableRow = (props) => {
    const { 
        children = null,
        ...restProps 
    } = props;

    return (
        <tr className="acaTable__row">
            {children}
        </tr>
    );

}



const AcaTable = (props) => {
    const { 
        classes = '',
        children = null,
        ...restProps 
    } = props;

    let classList = "acaTable " + classes;

    return (
        <div className="acaTable__wrapper">
            <table className={classList}>
                {children}
            </table>
        </div>
    );

}



/**
 * Export
 */
export { AcaTable, AcaTableHeader, AcaTableRow, AcaTableCell };